import { render, staticRenderFns } from "./servicerQr.vue?vue&type=template&id=461af688&"
import script from "./servicerQr.vue?vue&type=script&lang=js&"
export * from "./servicerQr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports